import $ from 'jquery';
import Unlink from './Unlink';
import 'slick-carousel';

const slickSettings = {
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
      },
    },
  ],
};

export default class Stats {
  constructor(element) {
    this.$element = $(element);
    this.settings = slickSettings;
    this.preprocess();
    this.slick = this.addSlickCarousel();
    this.ready();
  }

  preprocess() {
    // Unlink this post from redirecting users.
    this.$element.find('.node-header a').each((i, element) => {
      if (!element.Unlink) {
        element.Unlink = new Unlink(element);
      }
    });
  }

  addSlickCarousel() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
